import React from 'react';
import PropTypes from 'prop-types';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
// Component
import ListPlaceStep1 from '../../components/ListPlaceStep1';
import s from './BecomeHost.css';

const BecomeHost = (props) => {

  const { title, formPage, formBaseURI, mode, listId, baseCurrency, step } = props;
  return (
    <ListPlaceStep1
      listId={listId}
      formPage={formPage}
      formBaseURI={formBaseURI}
      mode={mode}
      baseCurrency={baseCurrency}
      step={step}
    />
  );
}

BecomeHost.propTypes = {
  title: PropTypes.string.isRequired,
  mode: PropTypes.string,
  listId: PropTypes.number,
  formBaseURI: PropTypes.string,
  mode: PropTypes.string
};

export default withStyles(s)(BecomeHost);